import React, { useState, useEffect, useCallback } from 'react';
import { Table, notification } from 'antd';
import { formatPrice } from '../../../../../utils/format';
import { apiDepositSellersSummary } from '../../../../../api/deposits';

const DepositSellersSummary = ({ depositId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchSummary = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const filters = {
        page: params.page || 1,
        page_size: params.pageSize || 10,
      };
      const response = await apiDepositSellersSummary(depositId, filters);
      setData(response.results || []);
      setPagination(prev => ({
        ...prev,
        total: response.count || 0,
        current: params.page || 1,
      }));
    } catch (error) {
      notification.error({
        message: "Erro",
        description: "Ocorreu um erro ao buscar o resumo dos vendedores.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  }, [depositId]);

  useEffect(() => {
    if (depositId) {
      fetchSummary();
    }
  }, [depositId, fetchSummary]);

  const handleTableChange = (pag) => {
    fetchSummary({
      page: pag.current,
      pageSize: pag.pageSize,
    });
  };

  const columns = [
    {
      title: 'Vendedor',
      dataIndex: ['account', 'display_name'],
      key: 'account',
    },
    {
      title: 'Total',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (val) => formatPrice(val),
    },
    {
      title: 'Transações',
      dataIndex: 'transaction_count',
      key: 'transaction_count',
    },
  ];

  if (!data.length && !loading) {
    return <p>Nenhum vendedor encontrado.</p>;
  }

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      size="small"
      pagination={{
        current: pagination.current,
        total: pagination.total,
        pageSize: pagination.pageSize,
        showSizeChanger: false,
      }}
      onChange={handleTableChange}
      bordered
      rowKey={(record) => record.id}
      scroll={{ x: 400 }}
    />
  );
};

export default DepositSellersSummary;
